
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crmoffers",
      function () {
        return require("private-next-pages/crmoffers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crmoffers"])
      });
    }
  